import React from 'react';
import Paper from '@mui/material/Paper';

const style = {
    paper: {
        marginTop:"50px",
        padding:"25px 30px 20px 25px",
    }
}

const FullscreenMessage = (props) => {
    return (
        <Paper style={style.paper}>
          <h2 style={{textAlign:"center", marginBottom:"35px"}}>
            {props.children}
          </h2>   
        </Paper>
    );
}

export default FullscreenMessage;
